import { render } from "./AddTaxNexus.vue?vue&type=template&id=9dcd2e16&scoped=true"
import script from "./AddTaxNexus.vue?vue&type=script&lang=js"
export * from "./AddTaxNexus.vue?vue&type=script&lang=js"

import "./AddTaxNexus.vue?vue&type=style&index=0&id=9dcd2e16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dcd2e16"],['__file',"src/views/Taxes/AddTaxNexus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9dcd2e16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9dcd2e16', __exports__)) {
    api.reload('9dcd2e16', __exports__)
  }
  
  module.hot.accept("./AddTaxNexus.vue?vue&type=template&id=9dcd2e16&scoped=true", () => {
    api.rerender('9dcd2e16', render)
  })

}


export default __exports__